import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    // Lets a card fill the height its row reserves, so the two side-by-side
    // configuration cards line up at the bottom instead of ending ragged.
    stretchCol: css`
      display: flex;

      > .ant-card {
        width: 100%;
      }
    `,

    // A failed run can report a message per candidate, so the list scrolls
    // inside the expanded row instead of pushing the table out of view.
    errorList: css`
      max-height: 220px;
      margin: 0;
      overflow-y: auto;
      padding-left: 20px;

      li {
        word-break: break-word;
      }

      li + li {
        margin-top: 4px;
      }
    `
  }
})
